import { useTranslation } from '../../../i18n/TranslationContext';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative w-full h-screen min-h-[650px] max-h-[900px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20dragon%20fruit%20inspired%20composition%20with%20vivid%20hot%20magenta%20pink%20and%20fresh%20green%20accents%2C%20soft%20cream%20white%20background%2C%20flowing%20organic%20curves%2C%20minimalist%20modern%20art%20direction%2C%20luxurious%20texture%2C%20warm%20atmospheric%20gradient%2C%20editorial%20fashion%20aesthetic&width=1800&height=1000&seq=hero-dragon-2026&orientation=landscape"
          alt="Dragonfruit"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-20">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/30 backdrop-blur-md text-background-50 text-xs font-medium mb-6 md:mb-8 border border-primary-300/40 whitespace-nowrap tracking-wide">
            {t('hero.tagline')}
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading text-background-50 leading-[1.05] mb-6 md:mb-8">
            {t('hero.title_line1')}
            <br />
            {t('hero.title_line2')}
          </h1>
          <p className="text-background-50/80 text-sm md:text-base max-w-xl leading-relaxed mb-8 md:mb-10">
            {t('hero.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="#contact"
              className="px-8 py-4 rounded-full bg-primary-500 text-background-50 font-bold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
            >
              {t('hero.cta_primary')}
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="#services"
              className="px-7 py-3.5 rounded-full bg-transparent text-background-50/80 font-normal text-sm border border-background-50/20 hover:bg-background-50/10 hover:text-background-50 hover:border-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
            >
              {t('hero.cta_secondary')}
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}